/* ============================================================
   gix.domains — LIVE TOKEN ENGINE
   ------------------------------------------------------------
   Applies live token overrides (from the settings page) on top of
   the committed values in gix-tokens.css, and persists them to
   localStorage so every gix page shares the same look.

   • Settings page edits tokens  → GIX_TOKENS.set(key,value)
   • Overrides persist in localStorage (key GIX_TOKENS_V1)
   • exportCSS() bakes the current values back into a full
     gix-tokens.css text (the "Update CSS" action).

   Load this AFTER gix-tokens.css on every gix page.
   ============================================================ */
(function () {
  "use strict";
  var LS = "GIX_TOKENS_V1_JEWELRY_V3";

  /* committed defaults — MUST match gix-tokens.css */
  var DEFAULTS = {
    /* colours */
    "--accent": "#3f7c89",
    "--teal-soft": "#7ea7af",
    "--warm": "#b06a3a",
    "--navy": "#16314a",
    "--navy-deep": "#102539",
    "--ink": "#14181c",
    "--ink-soft": "#4a5056",
    "--ink-mute": "#8a9095",
    "--paper": "#fbfbfa",
    "--surface": "#ffffff",
    "--surface-2": "#f1f1ef",
    "--line": "rgba(20,24,28,.12)",
    "--dark-bg": "#0c0e10",
    "--dark-surface": "#15181b",
    "--ink-dark": "#f1f2f3",
    /* type */
    "--display": '"Fira Sans Condensed",sans-serif',
    "--body": '"Barlow",sans-serif',
    "--mono": '"IBM Plex Mono",ui-monospace,monospace',
    /* spacing */
    "--maxw": "1200px",
    "--pad": "clamp(20px,4.4vw,56px)",
    /* shadow */
    "--card-shadow": "0 1px 0 rgba(20,24,28,.02),0 18px 40px -30px rgba(20,24,28,.40)"
  };

  /* overrides win over gix-tokens.css → same/higher specificity + later source */
  var SCOPE = '.page--s3[data-theme="light"]';

  function load() { try { return JSON.parse(localStorage.getItem(LS)) || {}; } catch (e) { return {}; } }
  var state = load();
  var subs = [];
  var styleEl = null;

  function apply() {
    var keys = Object.keys(state);
    var css = keys.length ? (SCOPE + "{" + keys.map(function (k) { return k + ":" + state[k] + ";"; }).join("") + "}") : "";
    if (!styleEl) {
      styleEl = document.createElement("style");
      styleEl.id = "gix-token-overrides";
      document.head.appendChild(styleEl);
    }
    styleEl.textContent = css;
  }
  function emit() { subs.forEach(function (fn) { try { fn(); } catch (e) {} }); }

  apply();

  window.GIX_TOKENS = {
    DEFAULTS: DEFAULTS,
    keys: function () { return Object.keys(DEFAULTS); },
    get: function (k) { return state[k] != null ? state[k] : DEFAULTS[k]; },
    isOverridden: function (k) { return state[k] != null; },
    set: function (k, v) {
      if (v == null || v === DEFAULTS[k]) delete state[k]; else state[k] = v;
      localStorage.setItem(LS, JSON.stringify(state)); apply(); emit();
    },
    reset: function (k) { delete state[k]; localStorage.setItem(LS, JSON.stringify(state)); apply(); emit(); },
    resetAll: function () { state = {}; localStorage.setItem(LS, JSON.stringify(state)); apply(); emit(); },
    restore: function (obj) { state = obj ? JSON.parse(JSON.stringify(obj)) : {}; localStorage.setItem(LS, JSON.stringify(state)); apply(); emit(); },
    overrides: function () { return Object.assign({}, state); },
    onChange: function (fn) { subs.push(fn); },

    /* full gix-tokens.css text with current values baked in */
    exportCSS: function () {
      var g = this;
      function v(k) { return g.get(k); }
      return [
        "/* ============================================================",
        "   gix.domains — DESIGN TOKENS  (single source of truth)",
        "   Generated by the settings page. Edit here or via settings.",
        "   ============================================================ */",
        "",
        "/* ---------- TYPE + GLOBAL RHYTHM ---------- */",
        ".page{",
        "  --display:" + v("--display") + ";",
        "  --body:" + v("--body") + ";",
        "  --mono:" + v("--mono") + ";",
        "  --maxw:" + v("--maxw") + ";",
        "  --pad:" + v("--pad") + ";",
        "  --ok:#3fd99a; --work:#f4b73d; --wait:#5f6e80;",
        "}",
        "",
        "/* ---------- BRAND PALETTE ---------- */",
        ".page--s3{",
        "  --maxw:" + v("--maxw") + ";",
        "  --pad:" + v("--pad") + ";",
        "  --accent:" + v("--accent") + ";",
        "  --accent-ink:#ffffff;",
        "  --accent-glow:rgba(63,124,137,.32);",
        "  --teal-soft:" + v("--teal-soft") + ";",
        "  --warm:" + v("--warm") + ";",
        "  --navy:" + v("--navy") + ";",
        "  --navy-deep:" + v("--navy-deep") + ";",
        "  --dark-bg:" + v("--dark-bg") + ";",
        "  --dark-surface:" + v("--dark-surface") + ";",
        "  --dark-line:rgba(255,255,255,.10);",
        "  --ink-dark:" + v("--ink-dark") + ";",
        "  --ink-dark-soft:#a8adb2;",
        "  --ink-dark-mute:#70757a;",
        "}",
        "",
        "/* ---------- LIGHT EDITORIAL THEME ---------- */",
        '.page--s3[data-theme="light"]{',
        "  --paper:" + v("--paper") + ";",
        "  --surface:" + v("--surface") + ";",
        "  --surface-2:" + v("--surface-2") + ";",
        "  --ink:" + v("--ink") + ";",
        "  --ink-soft:" + v("--ink-soft") + ";",
        "  --ink-mute:" + v("--ink-mute") + ";",
        "  --line:" + v("--line") + ";",
        "  --card-shadow:" + v("--card-shadow") + ";",
        "}",
        ""
      ].join("\n");
    }
  };
})();

/* ============================================================
   gix.domains — PER-RULE STYLE OVERRIDES  (GIX_RULES)
   ------------------------------------------------------------
   The mechanism every SECTION template uses for non-token styling
   (padding, size, width, radius, font-size …). Each control writes
   one declaration into a named rule; everything persists and is
   applied as a single <style> block, so edits propagate to every
   gix page that uses that component class.

      GIX_RULES.set('status', '.page--s3 .status', 'border-radius', '13px')

   Selectors stay scoped to component classes (e.g. .page--s3 .status)
   so they update the real site, not just the settings preview.
   ============================================================ */
(function () {
  "use strict";
  var LS = "GIX_RULES_V1_JEWELRY_V3";
  function load() { try { return JSON.parse(localStorage.getItem(LS)) || {}; } catch (e) { return {}; } }
  var rules = load();           /* id -> { selector -> {prop:val} } */
  var subs = [];
  var styleEl = null;

  function apply() {
    var blocks = [];
    Object.keys(rules).forEach(function (id) {
      var sels = rules[id] || {};
      Object.keys(sels).forEach(function (sel) {
        var props = Object.keys(sels[sel] || {});
        if (props.length) blocks.push(sel + "{" + props.map(function (p) { return p + ":" + sels[sel][p] + ";"; }).join("") + "}");
      });
    });
    if (!styleEl) {
      styleEl = document.createElement("style");
      styleEl.id = "gix-rule-overrides";
      document.head.appendChild(styleEl);
    }
    styleEl.textContent = blocks.join("\n");
  }
  function save() { localStorage.setItem(LS, JSON.stringify(rules)); }
  function emit() { subs.forEach(function (fn) { try { fn(); } catch (e) {} }); }

  apply();

  window.GIX_RULES = {
    get: function (id, sel, prop) { return rules[id] && rules[id][sel] ? rules[id][sel][prop] : undefined; },
    has: function (id, sel, prop) { return !!(rules[id] && rules[id][sel] && rules[id][sel][prop] != null); },
    set: function (id, sel, prop, val) {
      if (!rules[id]) rules[id] = {};
      if (!rules[id][sel]) rules[id][sel] = {};
      if (val == null || val === "") delete rules[id][sel][prop]; else rules[id][sel][prop] = val;
      if (!Object.keys(rules[id][sel]).length) delete rules[id][sel];
      if (!Object.keys(rules[id]).length) delete rules[id];
      save(); apply(); emit();
    },
    resetId: function (id) { delete rules[id]; save(); apply(); emit(); },
    resetAll: function () { rules = {}; save(); apply(); emit(); },
    restore: function (obj) { rules = obj ? JSON.parse(JSON.stringify(obj)) : {}; save(); apply(); emit(); },
    all: function () { return JSON.parse(JSON.stringify(rules)); },
    onChange: function (fn) { subs.push(fn); },
    exportCSS: function () {
      var out = [];
      Object.keys(rules).forEach(function (id) {
        var sels = rules[id] || {}; var any = [];
        Object.keys(sels).forEach(function (sel) {
          var props = Object.keys(sels[sel] || {});
          if (props.length) any.push(sel + "{\n" + props.map(function (p) { return "  " + p + ":" + sels[sel][p] + ";"; }).join("\n") + "\n}");
        });
        if (any.length) out.push("/* " + id + " */\n" + any.join("\n"));
      });
      return out.length ? ("/* gix component overrides — generated */\n\n" + out.join("\n\n") + "\n") : "";
    }
  };
})();
